import { Selection } from 'd3';
type SvgEl = Selection<SVGGElement, unknown, HTMLElement, any>;

export function bindBarEvents(svg: SvgEl, identifier, events) {
  const sel = svg.selectAll(identifier);

  Object.keys(events).forEach((k) => {
    sel.on(k, events[k]);
  });

  return sel;
}

export default {
  bindBarEvents,
};
